import React from "react";
import { Link } from "react-router-dom";
import "../../assets/css/breadcrumb.scss";
import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";

const DEVCENTER_TOOLS_URL = process.env.REACT_APP_DEVCENTER_URL + "/tools/";

function Breadcrumb(props) {
  const { t } = useTranslation("translation");

  function BreadCrumbClassification(pageType) {
    switch (pageType) {
      case "run-example":
        return (
          <ol className="breadcrumb-list">
            <li className="breadcrumb-item">
              <span>{t("breadcrumb.run")}</span>
            </li>
          </ol>
        );
      case "webhwp-example":
        return (
          <ol className="breadcrumb-list">
            <li className="breadcrumb-item">
              <a
                className="link devcenter-tools"
                href={DEVCENTER_TOOLS_URL}
                rel="noreferrer"
              >
                <span className="before">{t("breadcrumb.example.tool")}</span>
              </a>
            </li>
            <li className="breadcrumb-item">
              <Link
                className="link"
                onClick={() => {
                  window.location.reload();
                }}
              >
                <span className="current">
                  {t("breadcrumb.example.webhwp")}
                </span>
              </Link>
            </li>
          </ol>
        );
    }
  }

  return (
    <Box className="breadcrumb">{BreadCrumbClassification(props.pageType)}</Box>
  );
}

export default Breadcrumb;
